// extracted by mini-css-extract-plugin
export default {"updateAuthenticator":"UpdateAuthenticator_updateAuthenticator__PL8Tb","cancelButton":"UpdateAuthenticator_cancelButton__X9jTh"};